import { useSelector } from "react-redux";
import { IMAGE_ADDRESS } from '../../../../apis';
import { Link } from 'react-router-dom';
import { useCartHandlers } from '../../../../utils/cartHandler';
import EmptyCart from '../../../../styles/images/svg/empty-cart.svg';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import { LazyLoadImage } from "react-lazy-load-image-component";
import DigiplusLogotype from "../../../../styles/images/svg/digiplus/logotype/fa.svg";
import DigiplusPurplePattern from "../../../../styles/images/svg/digiplus/logotype/digiplus-purple-pattern.svg";
import Product1JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product1WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product2JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product2WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product3JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product3WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product4JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product4WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product5WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product5JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product6WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product6JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product7WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product7JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product8WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product8JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product9WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product9JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product10WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product10JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product11WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product11JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product12WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product12JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product13WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product13JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product14WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product14JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product15WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product15JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product16WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product16JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product17WEBP from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product17JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


const Cart = () => {
 	
 	const { token } = useSelector(state => state.login);
 	const { carts, totalPrice } = useSelector(state => state.shoppingCart);

 	const { handleAddToCartTwo, handleMinusBtnTwo } = useCartHandlers(null, null, null);

 	const totalProductPrice = carts.reduce((sum, item) => {
	  	const price = item.marketPrice !== null ? item.marketPrice : item.price;
	  	return sum + (price * item.number);
	}, 0);
 	const profit = totalProductPrice - totalPrice;
 	const profitPercent = totalProductPrice > 0 ? Math.floor((totalProductPrice - totalPrice) * 100 / totalProductPrice) : 0;

 	const naMojud = 1 === 2; // design amade shode vase kalahaye namojud. age in shart bargahrar beshe ghabele moshahede hast
 	// const profit = totalProductPrice / 10

 	const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

 	const alsoBuy = [
 		{imgWebp: Product3WEBP, imgJpg: Product3JPG, title: 'محافظ صفحه نمایش ریکام مدل CH UV مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۱۰۲,۳۷۰'}, 
 		{imgWebp: Product4WEBP, imgJpg: Product4JPG, title: 'کاور نیلکین مدل Super Frosted Shield Pro مناسب برای گوشی موبایل سامسونگ Galaxy S23 Ultra', price: '۶۴۰,۰۰۰'}, 
 		{imgWebp: Product5WEBP, imgJpg: Product5JPG, title: 'محافظ صفحه نمایش کوکونات مدل UDB UV مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra  به همراه محافظ پشت گوشی', price: '۴۴۰,۰۰۰'}, 
 		{imgWebp: Product6WEBP, imgJpg: Product6JPG, title: 'محافظ لنز دوربین بادیگارد مدل رینگی مناسب برای گوشی موبایل سامسونگ Galaxy S23 Ultra', price: '۹۲,۰۰۰'}, 
 		{imgWebp: Product7WEBP, imgJpg: Product7JPG, title: 'محافظ صفحه نمایش شیشه ای بادیگارد مدل FS مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۱۹۵,۰۰۰'}, 
 		{imgWebp: Product8WEBP, imgJpg: Product8JPG, title: 'محافظ صفحه نمایش جی اف مدل Diamond SuperD مناسب برای گوشی موبایل سامسونگ Galaxy S24 Plus', price: '۱۹۰,۰۰۰'}, 
 		{imgWebp: Product9WEBP, imgJpg: Product9JPG, title: 'محافظ صفحه نمایش کوکونات مدل UD UV مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra  به همراه محافظ پشت گوشی', price: '۴۴۰,۰۰۰'}, 
 		{imgWebp: Product10WEBP, imgJpg: Product10JPG, title: 'محافظ صفحه نمایش کوکونات مدل UD UV مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۲۹۰,۰۰۰'}, 
 		{imgWebp: Product11WEBP, imgJpg: Product11JPG, title: 'محافظ لنز دوربین زیرو مدل 3D-ZR مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۱۰۸,۰۷۰'}, 
 		{imgWebp: Product12WEBP, imgJpg: Product12JPG, title: 'کاور بادیگارد مدل Armor مناسب برای گوشی موبایل سامسونگ Galaxy S24 Plus', price: '۱۷۵,۰۰۰'}, 
 		{imgWebp: Product13WEBP, imgJpg: Product13JPG, title: 'محافظ صفحه نمایش شیشه ای کولینگ مدل Olka Glass UV مناسب برای گوشی موبایل Galaxy S23 Ultra', price: '۱۰۵,۰۰۰'}, 
 		{imgWebp: Product14WEBP, imgJpg: Product14JPG, title: 'محافظ صفحه نمایش جی اف مدل Diamond UV مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۲۰۰,۰۰۰'}, 
 		{imgWebp: Product15WEBP, imgJpg: Product15JPG, title: 'کیف کلاسوری سامسونگ مدل EF-ZS918 مناسب برای گوشی موبایل سامسونگ Galaxy S23 Ultra', price: '۲,۵۷۷,۰۰۰'}, 
 		{imgWebp: Product16WEBP, imgJpg: Product16JPG, title: 'محافظ لنز دوربین یوریل مدل رینگی مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۱۲۰,۰۰۰'}, 
 	];


 	const recentViews = [
 		{imgWebp: Product2WEBP, imgJpg: Product2JPG, title: 'کاور یانگ کیت مدل Mechanical مناسب برای گوشی موبایل سامسونگ Galaxy S24 Ultra', price: '۱,۳۷۰,۰۰۰', oldPrice: '', desc: 'تنها ۲ عدد در انبار باقی مانده', descClass: 'text-primary-700', svg: '', timeRemaining: '', discount: ''}, 
 		{imgWebp: Product1WEBP, imgJpg: Product1JPG, title: 'گوشی موبایل سامسونگ مدل Galaxy S24 Ultra دو سیم کارت ظرفیت 256 گیگابایت و رم 12 گیگابایت - ویتنام ', price: '۶۴۰,۰۰۰', oldPrice: '', desc: 'ارسال امروز', descClass: 'text-neutral-600', svg: 'deliveryToday', timeRemaining: '', discount: ''}, 
 		{imgWebp: Product17WEBP, imgJpg: Product17JPG, title: 'شامپو مو لابورن مدل Wheat Germ Protein حجم 300 میلی لیتر', price: '۴۹,۹۰۰', oldPrice: '۱۰۴,۰۰۰', desc: 'ارسال امروز', descClass: 'text-neutral-600', svg: 'deliveryToday', timeRemaining: '۲۲ : ۰۱ : ۱۰', discount: '۵۲٪'}, 
 	];

    return (

    	<div className="grow bg-neutral-000 flex flex-col w-full items-center shrink-0" style={{paddingTop: '188px', paddingLeft: '0px', paddingBottom: '0px'}}>
			<div id="base_layout_desktop_static_header" className="w-full">
			</div>
			<div id="base_layout_desktop_sticky_header" className="sticky bg-neutral-000 z-3 w-full styles_BaseLayoutDesktop__stickyHeader__LYwWR">
			</div>
			<div className="grow bg-neutral-000 flex flex-col w-full items-center styles_BaseLayoutDesktop__content__hfHD1 container-xl-w px-6">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
				</div>
				<div>
					<ul className="flex relative border-complete-b-200">
						<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-primary-500 text-subtitle-strong cursor-pointer">
							<div className="flex items-center select-none" data-cro-id="cart-main-cart">
								<span className="text-subtitle-strong">سبد خرید
								</span>
								{ carts.length > 0 &&
								<span className="rounded-small text-neutral-000 mr-1 flex items-center justify-center text-body2-strong styles_TabTitle--active__rzfBE styles_TabTitle__bgsKt">{toPersianDigits(carts.length)}
								</span>
								}
							</div>
							<div className="absolute bottom-0 styles_Tab__border__6fH9m">
							</div>
						</li>
						<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-subtitle text-neutral-500 cursor-pointer">
							<div className="flex items-center select-none" data-cro-id="cart-next-purchase">
								<span className="text-subtitle">خرید بعدی
								</span>
							</div>
							<div className="absolute bottom-0 opacity-0 styles_Tab__border__6fH9m">
							</div>
						</li>
					</ul>
					<ul className="lg:pt-3">
						<li>
							<div>
								<div className="lg:flex">
									<section className="mb-3 lg:mb-0 grow border-complete-b-200 lg:border-none lg:pl-3">
										
										<div className="p-0">
										{ carts.length === 0 ?
											<div className="py-6 lg:px-0 bg-neutral-000 rounded-large">
												<div className="flex justify-center">
													<div style={{width: '200px', height: '150px', lineHeight: '0'}}>
														<LazyLoadImage className="w-full inline-block" src={EmptyCart} width="200" height="150" alt="empty-cart" title="" style={{objectFit: 'contain'}} />
													</div>
												</div>
												<p className="text-h4 text-neutral-800 text-center mt-6">سبد خرید شما خالی است!</p>
											</div>
											:
											<div className="lg:rounded-medium relative styles_Frame__Lu_I7 overflow-hidden !border-none" id="border-none-1" >
												<div className="styles_SimpleList__4Oxc9 px-6">
													<div className="w-full flex items-start">
														<div className="flex grow items-center">
															<div className="flex items-start grow">
																<div className="grow text-right">
																	<div className="break-words py-3">
																		<div className="flex items-center grow">
																			<p className="grow text-h5 text-neutral-900">
																				<span className="relative">
																					<div>
																						<div>سبد خرید شما 
																							<span className="text-icon-low-emphasis text-body-2">. {toPersianDigits(carts.length)} مرسوله
																							</span>
																						</div>
																					</div>
																				</span>
																			</p>
																			<div>
																				<button data-cro-id="cart-more-infos" type="button">
																					<div className="flex">
																						<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																							<use xlinkHref="#moreVert"></use>
																						</svg>
																					</div>
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="lg:rounded-medium relative styles_Frame__Lu_I7 p-0 mb-3 !border-none" id="border-none-1">
												{
													carts.map((cart, index) => {
														return (
															<div className="relative br-list-vertical-no-padding-200 px-4">
																<div className="absolute top-0 left-0 bg-neutral-000 w-full h-full flex items-center justify-center pointer-events-none opacity-0">
																	<div className="flex flex-col justify-center items-center py-4">
																		<div style={{width: '36px', height: '36px', lineHeight: '0'}}>
																			<picture>
																				<source type="image/webp" srcSet={Product1WEBP} />
																				<source type="image/jpeg" srcSet={Product1JPG} />
																				<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain', width: '36px', height: '36px'}}>
																				</span>
																			</picture>
																		</div>
																		<p className="text-subtitle-strong text-neutral-800 my-3">کالای موردنظر شما حذف شد
																		</p>
																		<div className="bg-neutral-200 rounded styles_RemovingItemBox__progressBarContainer__9Y2LV">
																			<div className="bg-neutral-400 rounded">
																			</div>
																		</div>
																		<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--white__6nwxQ rounded-medium focus:outline-none font-bold">
																			<div className="flex items-center justify-center relative grow">بازگرداندن کالا
																				<div className="flex text-neutral-600 mr-2">
																					<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																						<use xlinkHref="#undo"></use>
																					</svg>
																				</div>
																			</div>
																		</button>
																	</div>
																</div>
																<div className="bg-neutral-000 py-4 lg:pr-4 mx-4 lg:mx-0" data-testid="cart-item">
																	{ naMojud && 
																		<div class="mb-3">
																			<div class="rounded">
																				<div class="flex">
																					<div class="flex mt-1">
																						<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-error)'}}>
																							<use xlinkHref="#[object Object]"></use>
																						</svg>
																					</div>
																					<span class="mr-2 text-body-2 text-hint-text-error">کالا ناموجود شده و به صورت خودکار از سبد حذف می‌شود.
																					</span>
																				</div>
																			</div>
																		</div>
																	}
																	<div className="styles_CartItem__grid__rZXPE">
																		<div className={`flex flex-col items-center ${naMojud ? 'opacity-50' : ''}`}>
																			<Link className="relative" to={`/product/${cart.slug}/${cart.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
																				<div style={{width: '114px', height: '114px', lineHeight: '0'}}>
																					<picture>
																						<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + cart.image} width="114" height="114" alt={cart.title} title="" style={{objectFit: 'contain'}} />
																					</picture>
																				</div>
																				<div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong hidden styles_CartItem__imageQuantity__bzt41">۱
																				</div>
																			</Link>
																			<div className="mr-2">
																				<div className="flex items-center text-h5 py-2 mt-2 flex-col">
																					<div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div className="overflow-x-hidden">
																			<div className={`${naMojud ? 'opacity-50' : ''}`}>
																				<h3 className="text-neutral-800 text-body1-strong mb-2">{cart.title}</h3>
																				{ cart.selectedVariant.attributeTile &&
																				<div className="flex">
																					<div className="flex mt-1">
																						{ cart.selectedVariant.optionColor ?
																						<svg style={{width: '18px', height: '18px', fill: `#${cart.selectedVariant.optionColor}`}}>
																							<use xlinkHref="#variationColor"></use>
																						</svg>
																						:
																						<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
														                                    <use xlinkHref="#variationSize"></use>
														                                </svg>
																						}
																					</div>
																					<p className="text-body-2 text-neutral-600 mr-2">{cart.selectedVariant.optionTitle}
																					</p>
																				</div>
																				}
																				<div className="flex">
																					<div className="flex mt-1">
																						<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																							<use xlinkHref="#seller"></use>
																						</svg>
																					</div>
																					<p className="text-body-2 text-neutral-600 mr-2">{cart.seller.title}
																					</p>
																				</div>
																			</div>
																			{naMojud &&
																				<div class="text-h4 text-neutral-800 mt-1">ناموجود</div>
																			}
																		</div>
																		<div className="flex flex-col items-center">
																		{ !naMojud &&
																			<div className="flex items-center justify-between user-select-none px-2 rounded-medium border-complete-200 item-quantity_ItemQuantity__box__5r4FJ">
																				<div onClick={() => handleAddToCartTwo(cart.seller, cart.selectedVariant, cart.product, cart.slug)} className="flex cursor-pointer">
																					<svg data-testid="quantity-increase" data-cro-id="cart-add-quantity" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																						<use xlinkHref="#addSimple"></use>
																					</svg>
																				</div>
																				<span className="flex flex-col items-center justify-between text-primary-500">
																					<span className="relative flex items-center justify-center text-h5">{toPersianDigits(cart.number)}
																					</span>
																					{/*<small className="text-caption text-neutral-300">حداکثر</small>*/}
																				</span>
																				<div onClick={() => handleMinusBtnTwo(cart.seller, cart.selectedVariant, cart.product, cart.slug)} className="flex cursor-pointer">
																					<svg data-testid="quantity-decrease" data-cro-id="cart-delete-item-right" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																						<use xlinkHref={`#${cart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																					</svg>
																				</div>
																			</div>
																		}
																		</div>
																		<div>
																		{ !naMojud &&
																			<div className="flex items-center justify-between">
																				<div>
																					<div className="flex items-center justify-start ml-4">
																						<div className="flex justify-start items-center gap-1">
																							<span className="text-h4 text-neutral-800">{toPersianDigits((cart.price * cart.number / 10).toLocaleString('fa'))}
																							</span>
																						</div>
																						<div className="flex items-center justify-between">
																							<div className="flex items-center">
																								<div className="flex">
																									<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																										<use xlinkHref="#toman"></use>
																									</svg>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div className="flex a-center flex-row-reverse ml-4">
																				</div>
																			</div>
																		}
																		</div>
																	</div>

																	{!naMojud &&
																	<div className="flex lg:justify-start mt-3">
																		<div className="flex mr-auto">
																			<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--secondary__Warw0 rounded-medium mr-auto" data-cro-id="cart-next-purchase-cta">
																				<div className="flex items-center justify-center relative grow">انتقال به خرید بعدی
																					<div className="flex mr-2">
																						<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-secondary)'}} />
																					</div>
																				</div>
																			</button>
																		</div>
																	</div>
																	}
																</div>
															</div>
														);
													})
												}
												</div>
											</div>
										}
										</div>
									</section>
									{carts.length > 0 &&
									<aside className="relative">
										<div className="sticky styles_CheckoutGrid__sideBar__ah_Qn" style={{top: '188px'}}>
											<div className="lg:border-complete-200 lg:rounded-medium pt-2">
												<div className="px-5">
													<div className="flex items-center justify-between pt-3 relative flex-wrap">
														<div className="flex items-center">
															<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
																<span>قیمت کالاها ({toPersianDigits(carts.length)})
																</span>
															</div>
														</div>
														<div className="flex items-center mr-auto">
															<div className="flex items-center flex-wrap justify-end">
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="!text-body-1 text-neutral-600 text-subtitle-strong">{toPersianDigits((totalProductPrice / 10).toLocaleString('fa'))}
																			</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-600)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="flex items-center justify-between pt-3 relative flex-wrap">
														<div className="flex items-center">
															<div className="mr-1 text-body2-strong flex items-center text-neutral-800">
																<span>جمع سبد خرید
																</span>
															</div>
														</div>
														<div className="flex items-center mr-auto">
															<div className="flex items-center flex-wrap justify-end">
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="!text-body-1 text-neutral-800 text-subtitle-strong">{toPersianDigits((totalPrice / 10).toLocaleString())}
																			</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-800)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													{ profit > 0 &&
													<div className="flex items-center justify-between pt-3 relative flex-wrap">
														<div className="flex items-center">
															<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
																<span className="text-hint-text-success text-body-1">سود شما از خرید</span>
															</div>
														</div>
														<div className="flex items-center mr-auto">
															<span className="ml-1 !text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">({toPersianDigits(profitPercent)}٪)</span>
															<div className="flex items-center flex-wrap justify-end">
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="!text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">{toPersianDigits((profit / 10).toLocaleString('fa'))}</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '16px', height: '16px', fill: 'rgb(46, 123, 50)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													}
													<div className="hidden lg:block mt-1 lg:my-4">
														{/*<Link to={`${token ? '/checkout/shipping/' : '/login/?backUrl=checkout/shipping/'}`} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="cart-continue-shopping" >*/}
														<Link to={`/checkout/shipping/`} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="cart-continue-shopping" >
															<div className="flex items-center justify-center relative grow">تایید و تکمیل سفارش
															</div>
														</Link>
													</div>
												</div>
											</div>
											<p className="text-neutral-500 text-caption my-3 hidden lg:block">هزینه این سفارش هنوز پرداخت نشده‌ و در صورت اتمام موجودی، کالاها از سبد حذف می‌شوند
											</p>
											<div className="bg-neutral-100 lg:bg-neutral-000 flex flex-col px-5 lg:px-0">
											</div>
										</div>
									</aside>
									}
								</div>
							</div>

							


							{/*<div className="lg:bg-neutral-000 bg-neutral-100 lg:pt-0 pt-2">
								<div className="flex flex-col relative overflow-hidden w-full pt-2 lg:border-complete-200 lg:rounded-medium styles_HorizontalProductCarousel__main__oHae5 lg:mt-4 mt-0 bg-neutral-000">
									<div className="break-words py-3 px-5 py-2 user-select-none">
										<div className="flex items-center grow">
											<p className="grow text-h5 text-neutral-900">
												<span className="relative">بازدیدهای اخیر
												</span>
											</p>
										</div>
										<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
										</div>
									</div>
									<div>
										<Swiper
											className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl"
											modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
				                            slidesPerView="auto"
				                            pagination={{clickable: true}}
				                            loop={false}
				                            navigation
				                            style={{ width: "100%" }}
				                            spaceBetween={24}>
										{
											recentViews.map((product, key) => {
												return (
													<SwiperSlide key={`recent-views-${key}`} style={{width: 'auto', height: 'auto'}}>
														<a className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full border-complete-l" target="_blank" href="/product/dkp-3086892/%D8%B4%D8%A7%D9%85%D9%BE%D9%88-%D9%85%D9%88-%D9%84%D8%A7%D8%A8%D9%88%D8%B1%D9%86-%D9%85%D8%AF%D9%84-wheat-germ-protein-%D8%AD%D8%AC%D9%85-300-%D9%85%DB%8C%D9%84%DB%8C-%D9%84%DB%8C%D8%AA%D8%B1/" style={{width: '192px', minWidth: '192px', maxWidth: '192px'}}>
															<div data-testid="product-card" className="h-full">
																<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
																	<div className="flex items-center justify-start mb-1">
																		<div className="ml-1" style={{width: '116px', height: '14px', lineHeight: '0'}}>
																			<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain', width: '116px', height: '14px'}}>
																			</span>
																		</div>
																		<div className="text-body2-extra grow">
																			<br />
																		</div>
																	</div>
																	<div className="flex grow relative flex-col">
																		<div className="">
																			<div className="flex items-stretch flex-col relative mb-1">
																				<div className="flex items-start mx-auto">
																					<div>
																						<div className="flex items-center justify-start gap-1 flex-wrap absolute top-0 right-0 z-1 style_ProductImage__miniBadges__uxcGX">
																							<br />
																							<br />
																						</div>
																						<div style={{width: '150px', height: '150px', lineHeight: '0'}}>
																							<picture>
																								<source type="image/webp" srcSet={product.imgWebp} />
																								<source type="image/jpeg" srcSet={product.imgJpg} />
																								<LazyLoadImage className="w-full rounded-medium inline-block" src={product.imgJpg} width="150" height="150" alt="گوشی موبایل سامسونگ مدل Galaxy S24 Ultra دو سیم کارت ظرفیت 256 گیگابایت و رم 12 گیگابایت - ویتنام " title="" style={{objectFit: 'contain'}} />
																							</picture>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div className="grow flex flex-col items-stretch justify-start">
																			<div>
																				<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_VerticalProductCard__productTitle__6zjjN">{product.title}</h3>
																			</div>
																			<div className="mb-1 flex items-center justify-between">
																				<div className="flex items-center" data-ab-id="">
																					{product.svg !== '' ?
																					<div className="flex shrink-0 ml-1">
																						<svg style={{width: '18px', height: '18px', fill: 'var(--color-delivery-jet-expansion)'}}>
																							<use xlinkHref={`#${product.svg}`}></use>
																						</svg>
																					</div>
																					:''}
																					<p className={`text-caption  ${product.descClass}`}>{product.desc}
																					</p>
																					<br />
																				</div>
																			</div>
																			<div className="pt-1 flex flex-col items-stretch justify-between">
																				<div className="flex items-center justify-between">
																					{product.discount !== '' ?
																					<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																						<span className="text-body2-strong" data-testid="price-discount-percent">{product.discount}
																						</span>
																					</div>
																					:''}
																					<div className="flex items-center justify-end gap-1 text-neutral-700  text-h5 grow">
																						<span data-testid="price-final">{product.price}
																						</span>
																						<div className="flex">
																							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																								<use xlinkHref="#toman"></use>
																							</svg>
																						</div>
																					</div>
																				</div>
																				<div className="flex items-center justify-between pl-5">
																					<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">{product.oldPrice}
																					</div>
																				</div>
																			</div>
																			<div className="mt-auto">
																				<div>
																					<div className="relative bg-neutral-100 invisible style_ProductPromotionTimeline__progress__JnKWE">
																						<div className="absolute bg-primary-700 h-full left-0 top-0 style_ProductPromotionTimeline--active__oYyta">
																						</div>
																					</div>
																					<div className="whitespace-nowrap flex justify-between pt-1">
																						<div className="invisible">
																							<span className="text-primary-700 text-body-strong ml-1">%
																							</span>
																							<span className="text-neutral-500 text-caption">فروش رفته
																							</span>
																						</div>
																						<div className="text-primary-700 text-body2-strong style_ProductPromotionTimeline__timer__zS6ZA">{product.timeRemaining}
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</article>
															</div>
														</a>
													</SwiperSlide>
												);
											})
										}
										</Swiper>
									</div>
								</div>
							</div>*/}



						</li>
					</ul>
				</div>
				<div className="z-2 flex flex-col hide-scrollbar styles_Layout__jJdiO hidden">
					<div className="grow bg-neutral-000 lg:rounded-large flex flex-col overflow-hidden styles_Layout__content__nlhKE">
						<header className="w-full bg-primary-500 text-white px-5 py-2">
							<div className="flex items-center justify-between"><h2 className="text-h4">پشتیبانی آنلاین</h2>
								<div className="flex cursor-pointer">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
										<use xlinkHref="#arrowLeft"></use>
									</svg>
								</div>
							</div>
						</header>
						<div className="">
						</div>
					</div>
				</div>
				<div className="relative">
					<button className="flex items-center justify-between text-button-1 styles_FabButton__5YQgj styles_FabButton--medium__5dCWs styles_FabButton--primary__fBOaQ p-3 fixed inline-block z-1 bottom-8 styles_Layout__CTAButton__WsxR_">
						<div className="flex items-center justify-center">
							<div className="flex styles_FabButton__icon__Nx9Sr">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#support"></use>
								</svg>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>

    );
}

export default Cart;